let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7tSfp")).then(() => parcelRequire('chn85'));